import script from "./ComputeClampingPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComputeClampingPage.vue?vue&type=script&lang=ts&setup=true"

import "./ComputeClampingPage.vue?vue&type=style&index=0&id=451619bd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-451619bd"]])

export default __exports__